// "use client";

// import React, { CSSProperties } from "react";
// import SocialIcons from "../socialIcons/SocialIcons";
// import "./style.css";
// interface SocialProps {
//     style?: CSSProperties
// }
// import Link from "next/link";

// export default function SocialMediaSection({ style }: SocialProps) {
//     return (
//         <div className="container my-5">
//             <div className="row">

//                 {/* LEFT ADS COLUMN */}
//                 <div className="col-2 d-flex flex-column gap-3">
//                 </div>

//                 {/* CENTER CONTENT */}
//                 <div className="col-lg-8 col-12">

//                     {/* TITLE ROW */}
//                     <div className="row mb-4">
//                         <div className="col-12 ">
//                             <h2>All Official Social Media Channels of Coinccino.</h2>
//                             <h4>
//                                 Whether it's YouTube, Instagram or LinkedIn: Discover our social channels and find the right platform for you.
//                             </h4>
//                         </div>
//                     </div>

//                     {/* SOCIAL MEDIA 3 COLUMNS */}
//                     <div className="row">

//                         {/* Youtube Column */}
//                         <div className="col-12 mb-3">
//                             <div className="p-3 border rounded h-100">
//                                 <div className="social-section-big">
//                                     <img className="logo" src="/social-media/Youtube.webp" alt="Youtube Logo"></img>
//                                 </div>
//                                 <p className="mt-2">
//                                     Join Coinccino on YouTube for tutorials, updates, and exclusive content.
//                                     industry connections, and valuable career insights.
//                                 </p>
//                                 <Link href="https://youtube.com/coinccino" target="_blank">
//                                     <button className="btn text-white text-uppercase"
//                                         style={{
//                                             background: "var(--ghost-accent-color)",
//                                             borderRadius: "999px",
//                                             padding: "12px 16px",
//                                             fontSize: "12px",
//                                             letterSpacing: "2px",
//                                         }}>Youtube</button>
//                                 </Link>
//                             </div>
//                         </div>

//                         {/* LinkedIn */}
//                         <div className="col-lg-4 col-12 mb-3">
//                             <div className="p-3 border rounded h-100">
//                                 <div className="social-section-big">
//                                     <img className="logo" src="/social-media/Linkedin.webp" alt="LinkedIn Logo"></img>
//                                 </div>

//                                 <p className="mt-2">
//                                     Join Coinccino on LinkedIn for professional networking,
//                                     industry connections, and valuable career insights.
//                                 </p>

//                                 <Link href="https://www.linkedin.com/company/coinccino/?viewAsMember=true" target="_blank">
//                                     <button className="btn text-white text-uppercase"
//                                         style={{
//                                             background: "var(--ghost-accent-color)",
//                                             borderRadius: "999px",
//                                             padding: "12px 16px",
//                                             fontSize: "12px",
//                                             letterSpacing: "2px",
//                                         }}>LinkedIn</button>
//                                 </Link>
//                             </div>
//                         </div>

//                         {/* X */}
//                         <div className="col-lg-4 col-12 mb-3">
//                             <div className="p-3 border rounded h-100">
//                                 <div className="social-section-big">
//                                     <img className="logo" src="/social-media/X.png" alt="X Logo"></img>
//                                 </div>
//                                 <p className="mt-2">
//                                     Follow Coinccino on X for breaking news, exclusive updates, expert analysis, and current insights.
//                                 </p>
//                                 <Link href="https://www.x.com/coinccino" target="_blank" className="btn text-white text-uppercase"
//                                     style={{
//                                         background: "var(--ghost-accent-color)",
//                                         borderRadius: "999px",
//                                         padding: "12px 16px",
//                                         fontSize: "12px",
//                                         letterSpacing: "2px",
//                                     }}>X</Link>
//                             </div>
//                         </div>

//                         {/* Facebook */}
//                         <div className="col-lg-4 col-12 mb-3">
//                             <div className="p-3 border rounded h-100">
//                                 <div className="social-section-big">
//                                     <img className="logo" src="/social-media/‌instagram.png" alt="Instagram Logo"></img>
//                                 </div>
//                                 <p className="mt-2">
//                                     Stay connected with Coinccino on Instagram for real-time updates and expert insights!
//                                 </p>

//                                 <Link href="https://www.facebook.com/coinccino" target="_blank" className="btn text-white text-uppercase"
//                                     style={{
//                                         background: "var(--ghost-accent-color)",
//                                         borderRadius: "999px",
//                                         padding: "12px 16px",
//                                         fontSize: "12px",
//                                         letterSpacing: "2px",
//                                     }}>Instagram</Link>
//                             </div>
//                         </div>

//                     </div>
//                 </div>

//                 {/* RIGHT ADS COLUMN */}
//                 <div className="col-2 d-flex flex-column gap-3">
//                 </div>

//             </div>
//         </div>
//     );
// }

"use client";

import React, { CSSProperties } from "react";
import "./style.css";
import Link from "next/link";

interface SocialLink {
  key: string;
  name: string;
  url: string;
}

interface SocialProps {
  style?: CSSProperties;
  socialLinks?: SocialLink[];
}
const socialOrder = [
  "youtube",
  "linkedin",
  "twitter",
  "instagram",
  "facebook",
  "pinterest",
  "telegram",
];

const socialConfig: Record<string, { logo: string; description: string }> = {
  youtube: {
    logo: "/social-media/Youtube.webp",
    description:
      "Subscribe on YouTube for detailed, in-depth videos and the latest news about the world of cryptocurrencies!",
  },
  linkedin: {
    logo: "/social-media/Linkedin.webp",
    description:
      "Join Coinccino on LinkedIn for professional networking, industry connections, and valuable career insights.",
  },
  twitter: {
    logo: "/social-media/X.png",
    description:
      "Follow Coinccino on X for breaking news, exclusive updates, expert analysis, and current insights.",
  },
  instagram: {
    logo: "/social-media/‌instagram.png",
    description:
      "Stay connected with Coinccino on Instagram for real-time updates and expert insights!",
  },
//   facebook: {
//     logo: "/social-media/Facebook.webp",
//     description:
//       "Follow Coinccino on Facebook for the latest news, updates, and community discussions.",
//   },
//   pinterest: {
//     logo: "/social-media/Pinterest.webp",
//     description:
//       "Discover Coinccino on Pinterest for curated crypto content and visual insights.",
//   },
//   telegram: {
//     logo: "/social-media/Telegram.webp",
//     description:
//       "Join Coinccino on Telegram for real-time alerts, discussions, and community updates.",
//   },
};

export default function SocialMediaSection({
  style,
  socialLinks = [],
}: SocialProps) {
  return (
    <div className="container my-5" style={style}>
      <div className="row">
        {/* LEFT ADS */}
        <div className="col-2 d-flex flex-column gap-3" />

        {/* CENTER */}
        <div className="col-lg-8 col-12">
          <div className="row mb-4">
            <div className="col-12">
              <h2>All Official Social Media Channels of Coinccino.</h2>
              <h4>
                Whether it's YouTube, Instagram or LinkedIn: Discover our social
                channels and find the right platform for you.
              </h4>
            </div>
          </div>

          <div className="row">
            {[...socialLinks]
              .sort(
                (a, b) =>
                  socialOrder.indexOf(a.key) - socialOrder.indexOf(b.key),
              )
              .map((social) => {
                const config = socialConfig[social.key];
                if (!config) return null;

                const isYoutube = social.key === "youtube";

                return (
                  <div
                    key={social.key}
                    className={`${isYoutube ? "col-12" : "col-lg-4 col-12"} mb-3`}
                  >
                    <div className="p-3 border rounded h-100">
                      <div className="social-section-big">
                        <img
                          className="logo"
                          src={config.logo}
                          alt={`${social.name} Logo`}
                        />
                      </div>
                      <p className="mt-2">{config.description}</p>
                      <Link
                        href={social.url}
                        target="_blank"
                        className="btn text-white text-uppercase"
                        style={{
                          background: "var(--ghost-accent-color)",
                          borderRadius: "999px",
                          padding: "12px 16px",
                          fontSize: "12px",
                          letterSpacing: "2px",
                        }}
                      >
                        {social.name}
                      </Link>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        {/* RIGHT ADS */}
        <div className="col-2 d-flex flex-column gap-3" />
      </div>
    </div>
  );
}
